import serviceTwo from './serviceTwo';
import { UrlBuilder } from './url-builder';

export const getCheckListForListing = async (page, pageSize, payload) => {
  const builder = new UrlBuilder(`/checklist/list-user-checklists`);

  builder.add('page', page);
  builder.add('PageSize', pageSize);

  const response = await serviceTwo.postTwo(builder.toString(), payload);
  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const createCheckList = async (payload) => {
  const response = await serviceTwo.postTwo(`/checklist/create-checklist`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const updateCheckList = async (payload) => {
  const response = await serviceTwo.postTwo(`/checklist/update-checklist`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getCheckList = async (payload) => {
  const response = await serviceTwo.postTwo(`/checklist/view-checklist`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getCheckListForDropDown = async (payload) => {
  const response = await serviceTwo.postTwo(`/checklist/list-checklists`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const assignCheckListToUser = async (payload) => {
  const response = await serviceTwo.postTwo(`/checklist/assign-checklist-to-users`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getAssignableUsers = async (payload) => {
  const response = await serviceTwo.postTwo(`/checklist/list-assignable-users`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getAssignedUsers = async (payload) => {
  const response = await serviceTwo.postTwo(`/checklist/list-checklist-assigned-users`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const removeAssignedUser = async (payload) => {
  const response = await serviceTwo.postTwo(`/checklist/remove-assigned-user`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getCheckListResponsesList = async (page, pageSize, payload) => {
  const builder = new UrlBuilder(`/checklist/list-responses-by-checklist`);

  builder.add('page', page);
  builder.add('PageSize', pageSize);

  const response = await serviceTwo.postTwo(builder.toString(), payload);
  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const viewCheckListAnsResponse = async (payload) => {
  const response = await serviceTwo.postTwo(`/checklist/view-response`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const getCheckListDocument = async (payload) => {
  const response = await serviceTwo.postTwo(`/checklist/get-checklist-document`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};
